import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addemployee',
  templateUrl: './addemployee.component.html',
  styleUrls: ['./addemployee.component.css']
})
export class AddemployeeComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;


  //Edit Get Values
  employeeColl: any = [];
 

  countryColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  employeeform = new FormGroup({
    employeeid: new FormControl(0),
    employeename: new FormControl('', Validators.required),
    description: new FormControl(''),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Employee";

  @Input() employeeid: number = 0
  @Input() employeename: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.employeeid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }         
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }         
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.employeeform.reset();
      this.fnInitializeEmployee();

      if (this.employeeid > 0) {
        this.fngetEmployee();
      }
    
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.employeeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeEmployee() {
    this.employeeform.setValue({

      employeeid: 0,
      employeename: '',
      description: '',
      inactive:false,
    })
  }
 
  //Get 
  fngetEmployee() {
   
    var data = {
      'employeeid': this.employeeid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmployee(data)
      .subscribe(
        (res) => {
          this.employeeColl = res.json().result;
          var editdata = this.employeeColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
 
    try {
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.employeeform.valid) {
        //Check
        var data = {
          'employeeid': this.employeeid,
          'employeename': this.employeeform.get('employeename').value,
          'description': this.employeeform.get('description').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.employeeform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
      
        this.appService.fnCheckEmployee(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.employeeform.get('employeeid').value > 0) {
                //Update Department
                this.fnSetEmployee(data);
              }
              else {
                //Insert Department
                this.fnInsertEmployee(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.employeeform.controls['employeename'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertEmployee(data) {

    this.appService.fnInsertEmployee(data).subscribe(
      (res) => {
        if (res.json().status === 200) {

          var result = res.json().result;

          var rtnemployeeid = 0;
          if (result.length > 0) {
            rtnemployeeid = result[0].employeeid
           
          }
          this.toastr.success('', "The new Employee has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.employeeid);

          this.emitData.emit(rtnemployeeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetEmployee(data) {

    this.appService.fnSetEmployee(data).subscribe(
      (res) => {
        if (res.json().result != "") {
          this.toastr.success('', "The Employee has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.employeeid, data.employeename);

          this.emitData.emit(this.employeeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.employeeform.setValue({

      employeeid: deptBO.employeeid,
      employeename: deptBO.employeename,
      description: deptBO.description,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
